import ScrollToTopButton from '@kopapro/components/misc/scrollToTop/scrollToTop';

export default ScrollToTopButton;
